// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e-B1Q","image":"styles_image__taV1+","hints":"styles_hints__VD2Op","action":"styles_action__UANlS"};